import React, { useState } from 'react';
import styled from 'styled-components';

const SwitchWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: end;
  position: absolute;
  top: 20%;
  left: 0;
  right: 0;
  z-index: 10;
  transform: translateY(-50%);
  gap: 5px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const SwitchButton = styled.button`
  flex: 1;
  max-width: 250px;
  background-color: ${(props) => (props.active ? '#d4af37' : 'rgba(1, 1, 1, 0.76)')};
  border: ${(props) => (props.active ? 'none' : '1px solid #d4af37')};
  color: ${(props) => (props.active ? '#111' : '#fff')};
  padding: 12px 30px;
  border-radius: 50px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;

  &:hover {
    background-color: ${(props) => (props.active ? '#d4af37' : '#333')};
  }

  @media screen and (max-width: 768px) {
    // margin-top: 10px;
    max-width: none; // deja que crezca al 100% si estás en mobile
    width: 70%;
  }
`;

const ModeSwitch = ({ onChange }) => {
  const [mode, setMode] = useState('individuos');

  const handleSwitch = (selected) => {
    setMode(selected);
    if (onChange) onChange(selected);
  };

  return (
    <SwitchWrapper>
      <SwitchButton
        active={mode === 'individuos'}
        onClick={() => handleSwitch('individuos')}
      >
        Tengo una idea
      </SwitchButton>
      <SwitchButton
        active={mode === 'empresas'}
        onClick={() => handleSwitch('empresas')}
      >
        Tengo una empresa
      </SwitchButton>
    </SwitchWrapper>
  );
};

export default ModeSwitch;
